import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Input = ({ className, onChange, text, error, renderIcon, label, value = '' }) => {

    return (
        <div className='flex width-100 items-center'>
            {renderIcon &&
                <i
                    aria-hidden={true}
                    className={'absolute pl6 pt6 pb6 md-py8'}>
                    {renderIcon}
                </i>
            }
            {label && <span className='absolute pl6 pb7 md-pb8 pointer-events-none'>
                {label}
            </span>}
            <input
                className={`border black width-100 pr6 pt6 pb6 md-py8 ${className ? className : ''} ${renderIcon ? 'pl8' : 'pl5 md-pl6'}`}
                onChange={onChange}
                placeholder={text}
                value={value}/>
            {error && <p className='mt5 red'>{error}</p>}
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
    error: PropTypes.string,
    text: PropTypes.string,
    label: PropTypes.string,
    renderIcon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.array
    ]),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
};

Input.propTypes = propTypes;

export default Input;
